import React, { FC, useCallback, useState } from 'react';
import { observer } from 'mobx-react';
import { DialogActions, Divider } from '@mui/material';
import styled from 'styled-components';
import Dialog from 'components/UI/Dialog';
import Text from 'components/UI/Text';
import Button from 'components/UI/Button';
import { theme } from 'components/UI';
import { useTranslation } from 'react-i18next';
import { useStores } from 'stores/hooks/hooks';
import { ResellerTreeNode, TreeGrower } from 'models/grower';
import MoveDialogGrowerResellerSelect from './MoveDialogGrowerResellerSelect';
// import ResellersTree from '../../ResellersTree/ResellersTree';

const StyledDialog = styled(Dialog)`
  padding: 0 1rem;
`;

const Container = styled.div`
  padding: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const Title = styled(Text)`
  font-weight: 800;
`;

interface MoveDialogProps {
  onHide: () => void;
  visible: boolean;
  title: string;
}

const MoveDialog: FC<MoveDialogProps> = observer(
  ({ visible = false, onHide, title }) => {
    const { t } = useTranslation('grower');
    const { resellersStore } = useStores();

    const [selectedGrowers, setSelectedGrowers] = useState<TreeGrower[]>([]);
    const [selectedDestination, setSelectedDestination] =
      useState<TreeGrower | null>(null);

    const handleSelectGrowers = useCallback((growers: TreeGrower[]) => {
      setSelectedGrowers(growers);
    }, []);

    const handleSelectDestination = useCallback(
      (reseller: TreeGrower | null) => {
        setSelectedDestination(reseller);
      },
      [],
    );

    const moveToAnotherReseller = useCallback(() => {
      console.log('Moving growers', selectedGrowers, 'to reseller', selectedDestination);
      const growerIds = selectedGrowers.map((grower) => grower.id);
      const destinationId = selectedDestination?.id;
      if (!destinationId) {
        console.error('No destination selected');
        return;
      }

      resellersStore.moveGrowerToReseller(growerIds, destinationId);
      onHide();
    }, [onHide, resellersStore, selectedDestination, selectedGrowers]);

    return (
      <StyledDialog
        open={visible}
        onClose={onHide}
        fullWidth
        maxWidth="lg"
        dialogTitle={title}
        titleWeight="bold"
        disableEscapeKeyDown
      >
        <Container>
          <Title>{t('choose_destination_distributor')}</Title>
          <MoveDialogGrowerResellerSelect
            selection={selectedGrowers}
            onSelectionChange={handleSelectGrowers}
            destination={selectedDestination}
            onDestinationChange={handleSelectDestination}
          />
        </Container>
        <Divider />
        <DialogActions>
          <Button
            onClick={moveToAnotherReseller}
            disabled={
              selectedGrowers.length === 0 || selectedDestination?.id == null
            }
          >
            <Text textcolor={theme.color.white} size="sm">
              {t('ok')}
            </Text>
          </Button>
          <Button onClick={onHide}>
            <Text textcolor={theme.color.white} size="sm">
              {t('cancel')}
            </Text>
          </Button>
        </DialogActions>
      </StyledDialog>
    );
  },
);

export default MoveDialog;
